import { getFirestore, collection, doc, getDoc } from "firebase/firestore";
import axios from "axios";
import { API_BASE_URL } from "../../utils/config";

export const getOrderTypes = async () => {
  const db = getFirestore();
  const orderTypesDocRef = doc(db, "orderTypes", "global");

  try {
    const docSnap = await getDoc(orderTypesDocRef);
    if (docSnap.exists()) {
      return docSnap.data().categories || [];
    } else {
      throw new Error("No categories were found");
    }
  } catch (error) {
    console.error("Error fetching categories:", error);
    throw error;
  }
};

export const editOrderTypes = async (user, updateData) => {
  try {
    if (!user) {
      throw new Error("User not authenticated");
    }

    const idTokenResult = await user.getIdTokenResult();
    if (!idTokenResult.claims.superAdmin) {
      throw new Error("You are not authorized to update order types.");
    }

    const idToken = await user.getIdToken();
    const res = await axios.put(
      `${API_BASE_URL}orderTypes/update`,
      updateData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${idToken}`,
        },
      }
    );

    return res;
  } catch (error) {
    if (error.isAxiosError) {
      throw new Error(error.message);
    }
    throw error;
  }
};
